<i18n>
{
  "cn": {
    "success": "上传成功",
    "error": "上传出错",
    "uploading": "上传中",
    "paused": "暂停中",
    "waiting": "等待中",
    "cmd5": "计算md5中..."
  },
  "en": {
    "success": "Success",
    "error": "Error",
    "uploading": "Uploading",
    "paused": "Paused",
    "waiting": "Waiting",
    "cmd5": "Computing MD5..."
  }
}
</i18n>

<template>
  <uploader
    ref="uploader"
    :options="options"
    :file-status-text="statusText"
    class="uploader-example"
    :single="single"
    :allow-file-types="allowFileTypes"
    :marker-example="exampleFile"
    @file-added="fileAdded"
    @file-success="fileSuccess"
  />
</template>

<script>
import APP_CONFIG from '@/../config.json'
import uploader from '@/plugins/vue-simple-uploader/components/uploader'
import SparkMD5 from 'spark-md5'
import { getExample } from '@/request/apis/common'

export default {
  components: {
    uploader
  },
  props: {
    dataName: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    allowFileTypes: {
      type: Array,
      default: () => {
        return ['yaml']
      }
    },
    // 是否只能一次上传一个文件
    single: {
      type: Boolean,
      default: true
    },
    exampleFile: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: {
        target: `${location.origin}${APP_CONFIG.API_PATH}/common/uploadFile?data_name=${this.dataName}&type=${this.fileType}&category=${this.category}`,
        testChunks: true,
        singleFile: this.single,
        maxRetries: 3,
        checkChunkUploadedByResponse: function (chunk, message) {
          let obj = JSON.parse(message)
          if (obj.data.skipUpload) {
            return true
          }
          return (obj.data.uploaded || []).indexOf(chunk.offset + 1) >= 0
        }
      },
      attrs: {
        accept: '*'
      },
      statusText: {
        success: this.$t('success'),
        error: this.$t('error'),
        uploading: this.$t('uploading'),
        paused: this.$t('paused'),
        waiting: this.$t('waiting'),
        cmd5: this.$t('cmd5')
      },
    }
  },

  computed: {
    // Uploader实例
    uploader () {
      return this.$refs.uploader.uploader
    }
  },

  mounted () {
    this.$nextTick(() => {
      window.uploader = this.$refs.uploader.uploader
    })
  },
  methods: {
    fileAdded (file) {
      this.computeMD5(file)
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5 (file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = 1024 * 1024 // 分片大小， 插件默认 1 * 1024 * 1024
      let chunks = file.chunks.length // 获取分片个数
      let spark = new SparkMD5.ArrayBuffer()

      file.pause()
      file.cmd5 = true // 添加校验md5的文字状态
      loadNext()

      fileReader.onload = e => {
        spark.append(e.target.result)

        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          let md5 = spark.end()
          this.computeMD5Success(md5, file)
          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`)
        }
      }

      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      function loadNext () {
        let start = currentChunk * chunkSize
        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },

    computeMD5Success (md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      Object.assign(this.uploader.opts, {
        query: {
          ...this.params
        }
      })
      file.cmd5 = false // 取消计算md5状态
      file.uniqueIdentifier = md5
      file.resume()
    },

    fileSuccess (rootFile, file, message) {
      let response = JSON.parse(message)
      if (this.fileType === 'config') {
        this.$emit('uploadConfigSuccess', new CustomEvent('uploadConfigSuccess', {
          detail: {
            fileId: response.data.id,
            fileContent: response.data.content
          }
        }))
      } else {
        this.$emit('uploadDataSuccess', new CustomEvent('uploadDataSuccess', {
          detail: {
            fileId: response.data.id
          }
        }))
      }
    }
  }
}
</script>

<style>
.uploader-example {
  width: 800px;
  padding: 16px;
  margin-top: 8px;
  font-size: 12px;
  background-color: #FBFBFB;
}
.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
